import { MantineThemeOverride } from '@mantine/core';
import { components } from 'theme/components';
import { brandColors, brandTypography } from 'theme/brand-tokens';

const theme: MantineThemeOverride = {
  fontFamily: brandTypography.fontFamily,
  black: '#353E45', // todo: define
  white: '#FFFFFF', // todo: define
  primaryColor: 'red',
  primaryShade: {
    light: 8,
  },
  fontSizes: {
    md: '14px',
  },
  colors: {
    gray: [...brandColors.gray],
    blue: [...brandColors.blue],
    red: [...brandColors.red],
    green: [...brandColors.green],
    white: [...brandColors.white],
  },
  components,
};

export default theme;
